<template>
  <div>
    <b-row>
      <b-col class="mb-1">
        <b-link :to="{ name: 'CommissionFee-list' }">
          <feather-icon icon="ArrowLeftIcon" />
          <span class="align-middle ml-50">Back to List</span>
        </b-link>
      </b-col>
    </b-row>
    <b-card title="Create New Commission">
      <validation-observer ref="simpleRules">
        <form ref="form" @submit.stop.prevent="validationForm">
          <b-row>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Commission Type"
                rules="required"
              >
                <b-form-group
                  label="Commission Type *"
                  label-for="commmissionType"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    v-model="requestData.commissionType"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="commissionTypes"
                    label="name"
                    :clearable="true"
                    input-id="commissionTypes"
                  >
                    <template #option="{ name }">
                      <span class="ml-50 align-middle"> {{ name }}</span>
                    </template>

                    <template #selected-option="{ id }">
                      <span class="ml-50 align-middle">
                        {{ id === 1 ? "Fixed" : "Percentage" }}</span
                      >
                    </template>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6" v-if="requestData.commissionType.id === 1">
              <validation-provider
                #default="{ errors }"
                name="Fixed Commission Type"
                rules="required"
              >
                <b-form-group
                  label="Fixed Type *"
                  label-for="commissionType"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    v-model="requestData.fixedType"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="fixedTypes"
                    label="name"
                    :clearable="true"
                    input-id="fixedTypes"
                  >
                    <template #option="{ name }">
                      <span class="ml-50 align-middle"> {{ name }}</span>
                    </template>

                    <template #selected-option="{ name }">
                      <span class="ml-50 align-middle"> {{ name }}</span>
                    </template>
                  </v-select>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6" v-if="requestData.commissionType.id === 2">
              <b-form-group
                label="Commission Percentage Amount"
                label-for="amount"
              >
                <validation-provider
                  #default="{ errors }"
                  name="amount"
                  rules="required|between:0,100"
                >
                  <b-form-input
                    id="amount-input"
                    v-model.number="requestData.amount"
                    :state="errors.length > 0 ? false : null"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Commission Date Range" label-for="DateRange">
                <validation-provider
                  name="DateRange"
                  #default="{ errors }"
                  rules="required"
                >
                  <flat-pickr
                    v-model="trxnDateRange"
                    class="form-control"
                    :config="{ mode: 'range' }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Merchant" label-for="name">
                <validation-provider
                  #default="{ errors }"
                  name="Merchant"
                  rules="required"
                >
                  <b-form-select
                    id="name"
                    v-model="requestData.merchantId"
                    :options="checkedmerchantIds"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              md="6"
              v-if="
                requestData.commissionType.id === 1 &&
                requestData.fixedType.id === 1
              "
            >
              <b-form-group label="Commission Amount" label-for="amount">
                <validation-provider
                  #default="{ errors }"
                  name="amount"
                  rules="required"
                >
                  <b-form-input
                    id="amount-input"
                    v-model.number="requestData.amount"
                    :state="errors.length > 0 ? false : null"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-card
            v-if="
              requestData.commissionType.id === 1 &&
              requestData.fixedType.id === 2
            "
          >
            <app-collapse accordion>
              <app-collapse-item title="Commission Range" :is-visible="true">
                <b-form @submit.prevent="addRange" label="Commission Range">
                  <validation-observer ref="nextLevel">
                    <b-row
                      v-for="(
                        item, index
                      ) in requestData.commissionRangeRequest"
                      :id="item.id"
                      :key="item.id"
                      ref="row"
                    >
                      <b-col md="3">
                        <b-form-group label="Minimum value of Range">
                          <validation-provider
                            #default="{ errors }"
                            name="minRange"
                            rules="required"
                          >
                            <b-form-input
                              id="minRange"
                              v-model.number="item.minRange"
                              :state="errors.length > 0 ? false : null"
                              type="number"
                              disabled
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col md="3">
                        <b-form-group label="Maximum value of Range">
                          <validation-provider
                            #default="{ errors }"
                            name="maxRange"
                            rules="required|above:@minRange"
                          >
                            <b-form-input
                              id="maxRange"
                              v-model.number="item.maxRange"
                              :state="
                                item.maxRange < item.minRange ? false : null
                              "
                              type="number"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col md="3">
                        <b-form-group label="Commission Amount">
                          <validation-provider
                            #default="{ errors }"
                            name="amount"
                            rules="required"
                          >
                            <b-form-input
                              id="amount-input"
                              v-model.number="item.amount"
                              :state="errors.length > 0 ? false : null"
                              type="number"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>

                      <b-col lg="2" md="3" class="mb-50">
                        <b-button
                          variant="outline-danger"
                          class="mt-0 mt-md-2"
                          @click="removeItem(index)"
                        >
                          <span>Delete</span>
                        </b-button>
                      </b-col>
                    </b-row>
                    <b-col cols="12">
                      <hr />
                    </b-col>
                    <b-button variant="primary" type="submit">
                      <feather-icon icon="PlusIcon" class="mr-25" />
                      <span>Next Level</span>
                    </b-button>
                  </validation-observer>
                </b-form>
              </app-collapse-item>
            </app-collapse>
          </b-card>
        </form>
      </validation-observer>

      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
    <b-col class="d-flex justify-content-end">
      <b-button
        class="center"
        variant="success"
        @click.prevent="validationForm"
      >
        <span>Save</span>
      </b-button>
    </b-col>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  BCard,
  BButton,
  BFormCheckbox,
  BCardBody,
  BCardHeader,
  BFormSelect,
  BOverlay,
  BLink,
  BForm,
} from "bootstrap-vue";
import { heightTransition } from "@core/mixins/ui/transition";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "@validations";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BCard,
    BButton,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    AppCollapse,
    AppCollapseItem,
    BCardBody,
    BCardHeader,
    vSelect,
    BOverlay,
    BLink,
    flatPickr,
    BForm,
  },
  mixins: [heightTransition],
  data() {
    return {
      trxnDateRange: "",
      trxnStartDate: "",
      trxnEndDate: "",
      isLoading: false,
      requestData: {
        merchantId: null,
        commissionType: null,
        fixedType: null,
        amount: null,
        effectiveDateFrom: null,
        effectiveDateTo: null,
        commissionRangeRequest: [{ minRange: 0, maxRange: 0, amount: 0 }],
      },
      commissionTypes: [
        { id: 1, name: "Fixed" },
        { id: 2, name: "Percentage" },
      ],
      fixedTypes: [
        { id: 1, name: "Single" },
        { id: 2, name: "Range" },
      ],
      required,
      merchants: JSON.parse(localStorage.getItem("companies")).filter(
        (c) => c.merchants
      ),
      checkedmerchantIds: [],
      nextSequence: 1,
    };
  },
  mounted() {
    this.initTrHeight();
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
    this.merchants.forEach((res) => {
      res.merchants.forEach((val) => {
        this.checkedmerchantIds.push({
          value: val.id,
          text: val.name,
        });
      });
    });
    this.requestData.commissionType = this.commissionTypes.find(
      (en) => en.name === "Fixed"
    );
    this.requestData.fixedType = this.fixedTypes.find(
      (en) => en.name === "Single"
    );
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  methods: {
    validationForm() {
      this.$store.dispatch("config/getActionPrivilege", "CommissionFee-Create");
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          if (this.trxnDateRange !== "") {
            const [trxnSttDate, trxnEdDate] = this.trxnDateRange.split(" to ");
            // this.trxnEndDate = `${trxnEdDate.trim()}`
            // this.trxnStartDate = `${trxnSttDate.trim()}`

            if (this.trxnDateRange.includes("to")) {
              this.requestData.effectiveDateFrom = trxnSttDate.trim();
              this.requestData.effectiveDateTo = trxnEdDate.trim();
            }
          }
          if (this.requestData.commissionType.id === 2) {
            this.requestData.commissionRangeRequest = null;
            this.requestData.fixedType = 0;
          } else if (
            this.requestData.commissionType.id === 1 &&
            this.requestData.fixedType.id === 2
          ) {
            this.requestData.amount = 0;
            this.requestData.fixedType = this.requestData.fixedType.id;
          } else if (
            this.requestData.commissionType.id === 1 &&
            this.requestData.fixedType.id === 1
          ) {
            this.requestData.commissionRangeRequest = null;
            this.requestData.fixedType = this.requestData.fixedType.id;
          }
          this.isLoading = true;
          this.requestData.commissionType = this.requestData.commissionType.id;

          axios
            .post("/Commission/api/V1.0/CommissionFee/Create", this.requestData)
            .then((res) => {
              this.isLoading = false;
              console.log(res);
              this.$bvModal
                .msgBoxOk("Data was submitted successfully", {
                  title: "Confirmation",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                })
                .then((result) => {
                  if (result) {
                    this.requestData.commissionType = this.commissionTypes.find(
                      (m) => this.requestData.commissionType === m.id
                    );
                    this.requestData.fixedType = this.fixedTypes.find(
                      (m) => this.requestData.fixedType === m.id
                    );
                    this.$router.push({ name: "CommissionFee-list" });
                  }
                });
            })
            .catch((res) => {
              this.requestData.commissionType = this.commissionTypes.find(
                (m) => this.requestData.commissionType === m.id
              );
              this.requestData.fixedType = this.fixedTypes.find(
                (m) => this.requestData.fixedType === m.id
              );
              this.isLoading = false;
              this.$bvModal.msgBoxOk(res.data.message, {
                title: "Error",
                size: "sm",
                buttonSize: "sm",
                okVariant: "danger",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true,
              });
            });
        }
      });
    },
    addRange() {
      this.$refs.nextLevel.validate().then((success) => {
        if (success) {
          this.nextSequence += 1;
          if (this.nextSequence < 2) {
            this.requestData.commissionRangeRequest.push({
              minRange: 0,
              maxRange: 0,
              amount: 0,
            });
          } else {
            this.requestData.commissionRangeRequest.push({
              minRange:
                this.requestData.commissionRangeRequest[
                  this.requestData.commissionRangeRequest.length - 1
                ].maxRange + 1,
              maxRange: 0,
              amount: 0,
            });
          }

          this.$nextTick(() => {
            this.trAddHeight(this.$refs.row[0].offsetHeight);
          });
        }
      });
    },
    removeItem(index) {
      this.nextSequence -= 1;
      this.requestData.commissionRangeRequest.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form);
      });
    },
  },
};
extend("above", {
  params: ["minRange"],
  validate(value, { minRange }) {
    return value > minRange;
  },
  message: "This field value must be above Minimum value",
});
</script>
